import React from 'react'
import "./subscriptionSetupDetails.scss"

import { IBasicSetupDetails } from '../BasicSetupDetails/BasicSetupDetails';
import ProductTourVideo from 'components/CommunityOnboardingComp/SetupDetailsUtilities/ProductTourVideo';
import PageRedirectButton from 'components/CommunityOnboardingComp/SetupDetailsUtilities/PageRedirectButton';

const SubscriptionSetupDetails: React.FC<IBasicSetupDetails> = ({
    subdomain, groupData, compSelected, description }
) => {
    const homepageUrl: string = "settings/subscriptions"
    const [isdisplayVideo, setDisplayVideo] = React.useState(false);

    return (
        <>
            {
                isdisplayVideo && (
                    <ProductTourVideo
                        isdisplayVideo={isdisplayVideo}
                        setDisplayVideo={setDisplayVideo}
                        videoId={1045162092}
                        sectionTitle="Watch How To Create Subscription Plans"
                    />
                )
            }
            <ul className='setup-details-items'>
                <span className='setup-details-items-span'>{description}</span>
                <li className='setup-detail'>
                    <div className="onboarding-message-content-container">
                        <div
                            className="onboarding-message-content"
                            onClick={() => setDisplayVideo(true)}
                        >
                            <img
                                className="onboarding-message-content-img"
                                src='https://static.group.app/assets/getting-started/Subscriptions%20-%206.png'
                                alt="How to create Subscription Plans"
                            />
                        </div>
                    </div>
                    <div className='setup-item-btn'>
                        <PageRedirectButton
                            url={homepageUrl}
                            subdomain={subdomain}
                            group={groupData}
                        />

                    </div>
                </li>
            </ul>

        </>
    )
}

export default SubscriptionSetupDetails
